// "Build it in 3D": the CornePLUS2 configurator. Corne build rules (replaces the tier variants):
//   - one base colour, black or white, RM370 / RM420 fixed; the base is never sold on its own
//   - required: layout (42 or 36 keys), case, plate (not needed with the Integrated-Plate 3D case), bottom
//   - optional: Poron + IXPE and PVC back film (both can be taken, or neither)
//   - presets only pre-fill the selections; Limited White stays fixed
// Prices and stock are the xcmkb.com store values (Corne Components, snapshot 2026-10-11). Each part is its own
// SKU, and the layout filter follows that stock: a part or build that is out of stock for 42 or 36 keys is greyed out.
// Model, looks and viewer come from crkbdplus2/configurator (copied here by its sync step).
(async function () {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const section = $('#build');
  if (!section) return;

  const MYR_TO_USD = 0.2439;                               // estimate only: checkout is charged in MYR, +7% for buyers outside Malaysia
  const LIMITED_OPEN = false;                              // Limited White: closed until it is back in stock
  // early-bird discount for the total: { pct, label } from the theme editor (window.CP2_PROMO), or ?promo=15 to preview it
  const PROMO = window.CP2_PROMO || (/[?&]promo=(\d+)/.test(location.search) ? { pct: +RegExp.$1, label: 'Early bird' } : null);
  const BASES = {
    black: { id: 'black', label: 'Black', price: 370, finish: 'finish/black', code: 'BLK' },
    white: { id: 'white', label: 'White', price: 420, finish: 'finish/white', code: 'WHT' },
  };
  // Shopify variants for each choice (also used by Add to cart)
  const PART = {
    base: { black: 49789275701507, white: 49791773049091 },
    socket: { lp: 49795297116419, mx: 49795297149187 },     // Corne: Hotswap Socket (RM0, one per keyboard; tracks socket stock)
    plate: { fr4: 49789589061891, fr4w: 49789775511811, cf: { 42: 49789589094659, 36: 49789589127427 }, pp36: 49789589160195 },
    bottom: { frosted: { 42: 49789589192963, 36: 49789589225731 },
      steel_clear: { 42: 45944816042243, 36: 49789734813955 } },   // CornePLUS2 is MX-spaced for both sockets: never the choc-spaced (LP) plate
    case: { cf: 49789589291267, white: 49789589324035, frame2: 49789589356803 },
    poron: { lp: 49789731143939, mx: 49789731176707 },
    film: 49789589258499,
  };
  // which variant a choice is, for a layout and socket (null = nothing to buy, e.g. plate built into the case)
  const partVariant = (slot, id, layout, socket) => {
    const v = slot === 'poron' ? PART.poron[socket] : slot === 'film' ? PART.film
      : PART[slot] && PART[slot][id];
    return v && typeof v === 'object' ? v[layout] || null : v || null;
  };
  // live store data written by the Shopify section: { variantId: [price, available, stock or null] } and the shopper's currency.
  // Availability always comes from the store; prices only when the page is in MYR (its labels say RM).
  const LIVE = window.CP2_SHOP || null;
  const live = (vid) => (LIVE && vid && LIVE.v[vid]) || null;
  const livePrice = (vid, fallback) => (LIVE && LIVE.currency === 'MYR' && live(vid) ? live(vid)[0] : fallback);
  const socketOK = (id) => { const v = LIVE && live(PART.socket[id]); return !v || v[1]; };   // one socket set per keyboard
  const EXTRA = { poron: 40, film: 19 };                   // optional sound dampening (store snapshot)
  const OPT = {
    socket: [{ id: 'lp', label: 'Low profile', em: 'Choc v1/v2', look: 'socket/lp', sw: '#2b2d31', price: 0, code: 'LP' },
      { id: 'mx', label: 'MX', em: '3/5 pin', look: 'socket/mx', sw: '#c9cdd2', price: 0, code: 'MX' }],
    plate: [{ id: 'none', label: 'Built into case', look: 'hidden', sw: 'transparent;box-shadow:inset 0 0 0 1px #c3c8cd', price: 0, code: 'NP' },
      { id: 'fr4', label: 'FR4', look: 'plates/fr4', sw: '#3b3a2c', price: 30, code: 'FR4' },
      { id: 'cf', label: 'Carbon fibre', look: 'plates/carbon', sw: 'repeating-linear-gradient(45deg,#1b1c1f 0 3px,#2d2f34 3px 6px)', price: 80, code: 'CF' },
      { id: 'pp36', label: 'PP', em: '36 keys, black', look: 'plates/fr4', sw: '#1f2024', price: 45, code: 'PP36' },
      { id: 'fr4w', label: 'White FR4', look: 'plates/fr4_white', sw: '#efefea;box-shadow:inset 0 0 0 1px #d5d8dc', price: 30, code: 'WFR4' }],
    bottom: [{ id: 'frosted', label: 'Frosted acrylic', look: 'bottoms/frosted', sw: '#e9eef2', price: 20, code: 'FRS' },
      { id: 'steel_clear', label: 'Polished steel + clear', look: 'bottoms/steel_clear', sw: 'linear-gradient(135deg,#f3f4f5,#a7adb4)', price: 60, code: 'STL' }],
    case: [{ id: 'frame2', label: 'Integrated-Plate 3D case', em: 'plate built in', look: 'case/frame2', sw: '#1d1e21', price: 50, code: 'IPC' },
      { id: 'cf', label: 'CF PETG', look: 'case/cf_petg', sw: '#1d1e21', price: 50, code: 'CFC' },
      { id: 'white', label: 'GF PETG white', look: 'case/gf_petg_white', sw: '#eeeeea;box-shadow:inset 0 0 0 1px #d5d8dc', price: 50, code: 'WHC' },
      { id: 'none', label: 'No case', look: 'hidden', sw: 'transparent;box-shadow:inset 0 0 0 1px #c3c8cd', price: 0, code: 'NC' }],
  };
  if (LIVE) {
    for (const b of Object.values(BASES)) b.price = livePrice(PART.base[b.id], b.price);
    for (const slot of ['plate', 'bottom', 'case'])
      for (const o of OPT[slot]) o.price = livePrice(partVariant(slot, o.id, 42, 'lp'), o.price);
    EXTRA.poron = livePrice(PART.poron.lp, EXTRA.poron);
    EXTRA.film = livePrice(PART.film, EXTRA.film);
  }
  const PRESETS = [
    { id: 'starter', label: 'Starter', base: 'black', picks: { plate: 'none', case: 'frame2', bottom: 'frosted', poron: false, film: false } },
    { id: 'standard', label: 'Standard', base: 'black', picks: { plate: 'fr4', case: 'cf', bottom: 'steel_clear', poron: false, film: false } },
    { id: 'signature', label: 'Signature', base: 'black', picks: { plate: 'cf', case: 'cf', bottom: 'steel_clear', poron: true, film: true } },
    { id: 'limited', label: 'Limited White', base: 'white', limited: true, picks: { plate: 'fr4w', case: 'white', bottom: 'steel_clear', poron: true, film: true } },
  ];
  // stock by layout (store snapshot). A part is available for a layout only if it is listed here for it.
  const STOCK = {
    plate: { fr4: [42, 36], cf: [42, 36], pp36: [36], fr4w: [42, 36] },
    bottom: { frosted: [42, 36], steel_clear: [42, 36] },
    case: { frame2: [42, 36], cf: [42, 36], white: [42, 36] },
    poron: [42, 36],
    film: [42, 36],
  };
  const inStock = (slot, id, layout) => {
    const v = slot === 'poron' || slot === 'film' ? STOCK[slot] : STOCK[slot] && STOCK[slot][id];
    if (!v || !v.includes(layout)) return false;           // layout rules (e.g. PP is 36 keys only)
    const vid = LIVE && partVariant(slot, id, layout, state.socket);
    return vid && live(vid) ? live(vid)[1] : true;           // the store says whether it is in stock
  };
  // rules: PP (36) is black, 36 keys only; white FR4 and GF PETG white belong to the white base
  const baseAllows = (slot, id, base) => {
    if (slot === 'plate' && id === 'pp36') return base === 'black';
    if ((slot === 'plate' && id === 'fr4w') || (slot === 'case' && id === 'white')) return base === 'white' && state.locked;   // white series: Limited White only
    return true;
  };

  const baseOf = () => (state.locked ? 'white' : 'black');              // the white series is Limited White only
  let refPreset = PRESETS[2];                              // what the +RM / -RM labels compare with (Signature at start)
  const state = { layout: 42, socket: 'lp', plate: 'cf', bottom: 'steel_clear', case: 'cf', poron: true, film: true, locked: false, switch: null, keycap: null };
  const keys = () => state.layout;
  const swQty = () => state.layout + 2;                   // switches come as keys + 2 spares: 44 for 42 keys, 38 for 36
  let viewer = null;
  const kc = (id) => KEYCAPS.find((k) => k[0] === id);
  const sw = (id) => SWITCHES.find((s) => s[0] === id);
  const rm = (n) => { n = Math.round(n * 100) / 100;        // cents only when there are any (switches are RM2.90 each)
    return 'RM' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); };
  const opt = (slot, id) => OPT[slot].find((x) => x.id === id);

  // a part is offered when the base allows it, the stock is there for this layout, and the case rules fit
  function enabled(slot, id) {
    if (state.locked) return id === state[slot];
    if (slot === 'case' && id === 'none') return state.plate !== 'none';   // no case only with a switch plate
    if (!baseAllows(slot, id, baseOf())) return false;
    if (slot === 'plate') {
      if (state.case === 'frame2') return id === 'none';          // the plate is built into the Integrated-Plate case
      if (id === 'none') return false;
    }
    if (id === 'none') return false;
    return inStock(slot, id, state.layout);
  }
  const poronOK = () => state.case !== 'frame2' && inStock('poron', null, state.layout);
  const filmOK = () => inStock('film', null, state.layout);

  // when a choice stops being allowed, move to the first one that is
  function fixPicks() {
    if (!socketOK(state.socket)) {                         // chosen socket type sold out: use the other one if it is in stock
      const other = state.socket === 'lp' ? 'mx' : 'lp';
      if (socketOK(other)) { state.socket = other; if (other === 'mx') state.switch = null; }
    }
    if (state.switch && swShort(sw(state.switch)[4])) state.switch = null;
    if (state.case === 'frame2') { state.plate = 'none'; state.poron = false; }
    else if (state.plate === 'none') state.plate = 'fr4';
    for (const slot of ['plate', 'bottom', 'case']) {
      if (!enabled(slot, state[slot])) {
        const first = OPT[slot].find((o) => enabled(slot, o.id));
        if (first) state[slot] = first.id;
      }
    }
    if (!poronOK()) state.poron = false;
    if (!filmOK()) state.film = false;
  }
  // every required part is picked, allowed and in stock
  const missing = () => {
    const out = [];
    if (!socketOK(state.socket)) out.push('hot-swap socket (out of stock)');
    if (state.case !== 'frame2' && !enabled('plate', state.plate)) out.push('switch plate');
    if (!enabled('bottom', state.bottom)) out.push('bottom');
    if (state.case !== 'none' && !enabled('case', state.case)) out.push('case');
    return out;
  };
  const presetOK = (p) => {
    if (p.limited && !LIMITED_OPEN) return false;
    const picks = p.picks;
    const plateOK = picks.plate === 'none' ? true : inStock('plate', picks.plate, state.layout) && baseAllows('plate', picks.plate, p.base);
    const caseOK = inStock('case', picks.case, state.layout) && baseAllows('case', picks.case, p.base);
    const bottomOK = inStock('bottom', picks.bottom, state.layout);
    const poronOKp = !picks.poron || inStock('poron', null, state.layout);
    const filmOKp = !picks.film || inStock('film', null, state.layout);
    return plateOK && caseOK && bottomOK && poronOKp && filmOKp;
  };
  const matchedPreset = () => PRESETS.find((p) => p.base === baseOf() && Object.entries(p.picks).every(([k, v]) => state[k] === v) && !!p.limited === state.locked);

  function partsTotal() {
    let t = ['plate', 'bottom', 'case'].reduce((a, slot) => a + opt(slot, state[slot]).price, 0);
    if (state.poron) t += EXTRA.poron;
    if (state.film) t += EXTRA.film;
    return t;
  }
  function total() {
    let t = BASES[baseOf()].price + partsTotal();
    if (state.switch) t += sw(state.switch)[2] * swQty();
    if (state.keycap) t += kc(state.keycap)[3];
    return t;
  }
  function buildCode() {
    return ['CP2', BASES[baseOf()].code, opt('plate', state.plate).code, opt('bottom', state.bottom).code,
      opt('case', state.case).code, state.poron ? 'PRN' : 'NF', state.film ? 'PVC' : 'NB', opt('socket', state.socket).code, state.layout].join('-');
  }
  // shareable build link: this page with ?build=<code> (+ &sw= / &kc= for switches and keycaps).
  // Opening it restores the same configuration (readBuildLink below); works the same on the Shopify product URL.
  function buildUrl() {
    const q = new URLSearchParams({ build: buildCode() });
    if (state.switch) q.set('sw', state.switch);
    if (state.keycap) q.set('kc', state.keycap);
    return location.origin + location.pathname + '?' + q.toString() + '#build';
  }
  function readBuildLink() {
    const q = new URLSearchParams(location.search);
    const p = (q.get('build') || '').toUpperCase().split('-');   // CP2-BASE-PLATE-BOTTOM-CASE-PRN|NF-PVC|NB-SOCKET-LAYOUT
    if (p.length !== 9 || p[0] !== 'CP2') return false;
    const byCode = (slot, c) => (OPT[slot].find((o) => o.code === c) || {}).id;
    state.layout = p[8] === '36' ? 36 : 42;
    state.locked = p[1] === 'WHT' && LIMITED_OPEN;                 // Limited White only while it is open for orders
    for (const [slot, c] of [['plate', p[2]], ['bottom', p[3]], ['case', p[4]], ['socket', p[7]]]) {
      const id = byCode(slot, c);
      if (id) state[slot] = id;
    }
    state.poron = p[5] === 'PRN';
    state.film = p[6] === 'PVC';
    state.switch = state.socket === 'lp' && sw(q.get('sw')) ? q.get('sw') : null;   // the listed switches are Choc only
    state.keycap = kc(q.get('kc')) ? q.get('kc') : null;
    fixPicks();
    refPreset = matchedPreset() || refPreset;
    return true;
  }

  function selection() {
    const one = (look, name) => ({ skipped: false, picks: look ? [{ look, name }] : [] });
    return {
      socket: opt('socket', state.socket).look, plate: opt('plate', state.plate).look, bottom: opt('bottom', state.bottom).look,
      case: opt('case', state.case).look, foam: state.poron ? 'foam/poron_ixpe' : 'hidden',
      finish: BASES[baseOf()].finish,
      switches: one(state.switch && 'switches/' + state.switch, state.switch && sw(state.switch)[1]),
      keycaps: one(state.keycap && kc(state.keycap)[5], state.keycap && kc(state.keycap)[1]),
    };
  }

  // ---------- panel ----------
  const panel = $('.panel', section);
  const css = document.createElement('style');
  css.textContent = '#build .sw button:disabled,#build .seg button:disabled{opacity:.38;cursor:not-allowed}' +
    '#consent-tick{accent-color:#1fb5cf}' +
    '#build .viewer{transition:background .9s ease}' +
    '#build .viewer.rgb-on{background:radial-gradient(80% 90% at 50% 55%,#3a3d42 0%,#1b1d20 75%)}' +
    '#build .viewer.rgb-on .vtop{color:rgba(255,255,255,.55)}';
  document.head.appendChild(css);
  const seg = $('.seg', panel);                              // the presets
  seg.innerHTML = PRESETS.map((p) => `<button class="press" data-set="${p.id}">${p.label}</button>`).join('');
  seg.style.gridTemplateColumns = 'repeat(4, 1fr)';
  const layoutSeg = document.createElement('div');
  layoutSeg.className = 'seg layout-seg';
  layoutSeg.style.cssText = 'grid-template-columns:repeat(2, 1fr);margin-top:10px';
  layoutSeg.innerHTML = [42, 36].map((n) => `<button class="press" data-layout="${n}">${n} keys</button>`).join('');
  seg.after(layoutSeg);
  const layoutNote = document.createElement('p');
  layoutNote.className = 'layout-note'; layoutNote.hidden = true;
  layoutNote.style.cssText = 'margin:8px 2px 0;font-size:12.5px;line-height:1.45;color:#3d4248';
  layoutSeg.after(layoutNote);
  const presetNote = document.createElement('p');
  presetNote.style.cssText = 'margin:8px 2px 0;font-size:12.5px;line-height:1.45;color:#3d4248';
  presetNote.textContent = 'Presets fill in the parts for you. You can change any of them, except Limited White, which is a fixed build.';
  layoutNote.after(presetNote);
  $$('.opt', panel).forEach((o) => o.remove());           // the static rows from the old tiers layout
  const anchor = $('#sw-open', panel);
  const ROWS = [['socket', 'Hot-swap socket', 'included in every build'], ['plate', 'Switch plate', 'required'], ['bottom', 'Bottom', 'required'], ['case', 'Case', 'required']];
  for (const [slot, title, tag] of ROWS) {
    const div = document.createElement('div');
    div.className = 'opt'; div.dataset.slot = slot;
    div.innerHTML = `<h4><span>${title}</span><span data-price>${tag}</span></h4><div class="sw">` +
      OPT[slot].filter((o) => o.id !== 'none' || slot === 'case').map((o) => `<button class="press" data-id="${o.id}"><i style="background:${o.sw}"></i>${o.label}${o.em ? ` <em>${o.em}</em>` : ''}</button>`).join('') + '</div>';
    panel.insertBefore(div, anchor);
  }
  // sound dampening: Poron + IXPE and PVC back film, each optional, both can be taken
  const sd = document.createElement('div');
  sd.className = 'opt'; sd.dataset.slot = 'sound';
  sd.innerHTML = '<h4><span>Sound dampening</span><span data-price>optional</span></h4><div class="sw">' +
    '<button class="press" data-toggle="poron"><i style="background:#141415"></i>Poron + IXPE</button>' +
    '<button class="press" data-toggle="film"><i style="background:linear-gradient(135deg,#f4f6f8,#cdd2d8)"></i>PVC back film</button></div>';
  panel.insertBefore(sd, anchor);

  // consent and the checkout gate
  const addBtn = $('#add', section);
  const gate = document.createElement('p');
  gate.className = 'gate-note';
  gate.style.cssText = 'margin:10px 2px 0;font-size:12.5px;line-height:1.45;color:#a4452c';
  gate.hidden = true;
  const consent = document.createElement('label');
  consent.className = 'consent';
  consent.style.cssText = 'display:flex;gap:10px;align-items:flex-start;margin:14px 0 10px;font-size:12.5px;line-height:1.45;color:#3d4248';
  consent.innerHTML = '<input type="checkbox" id="consent-tick" style="margin-top:3px;flex:none"><span>If I choose regular shipping (not DDP), I am responsible for the import duties and taxes charged by my country. CornePLUS2 is designed, assembled and shipped from Malaysia.</span>';
  if (addBtn) { addBtn.before(gate); addBtn.before(consent); }
  const oneBuild = document.createElement('p');
  oneBuild.className = 'one-build';
  oneBuild.style.cssText = 'margin:10px 2px 0;font-size:12px;line-height:1.45;color:#6b7078;text-align:center';
  oneBuild.innerHTML = 'One CornePLUS2 build per order. Want two? Email <a href="mailto:support@xcmkb.com" style="color:inherit;text-decoration:underline">support@xcmkb.com</a> with both build links.';
  if (addBtn) addBtn.after(oneBuild);
  const tick = consent.querySelector('input');
  tick.addEventListener('change', () => update());

  // ---------- add to cart: the build goes into the Shopify cart as ordinary line items ----------
  // base (CornePLUS2), each part (Corne Components / Martensitic Steel Plate), switches (one per key) and keycaps.
  // The base line carries the build code and link so the order shows the whole configuration; the other lines
  // carry a hidden _build tag. Shopify's /cart/add.js is same-origin, so this only works on the store.
  function cartItems() {
    const L = state.layout, code = buildCode(), tag = { _build: code };
    const m = matchedPreset();
    const items = [{ id: PART.base[baseOf()], quantity: 1, properties: {
      Package: m ? m.label : 'Custom build', Build: code, 'Build link': buildUrl(), Layout: L + ' keys', Socket: opt('socket', state.socket).label } }];
    const add = (id, quantity = 1) => { if (id) items.push({ id, quantity, properties: tag }); };
    const plate = PART.plate[state.plate];
    if (state.case !== 'frame2') add(typeof plate === 'object' ? plate[L] : plate);
    add(PART.bottom[state.bottom][L]);
    add(PART.case[state.case]);
    add(PART.socket[state.socket]);
    if (state.poron) add(PART.poron[state.socket]);
    if (state.film) add(PART.film);
    if (state.switch) add(sw(state.switch)[4], swQty());
    if (state.keycap) add(kc(state.keycap)[6]);
    return items;
  }
  window.cp2CartItems = cartItems;                         // for checking the mapping from the console
  if (addBtn) addBtn.addEventListener('click', async () => {
    if (addBtn.disabled) return;
    const label = $('#add-label'), root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!window.Shopify) {                                 // the local mockup has no cart
      label.textContent = 'Checkout works on the store';
      setTimeout(() => { label.textContent = 'Checkout'; }, 2200);
      return;
    }
    addBtn.disabled = true; label.textContent = 'Going to checkout…';
    try {
      // one CornePLUS2 build per order: Checkout always means "buy the build on screen", so every earlier
      // CornePLUS2 build in the cart (any code, plus a loose CornePLUS2 base) goes first. Other items stay.
      // Two builds: the customer emails us with both build links.
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json());
      const isCp2 = (v) => typeof v === 'string' && v.startsWith('CP2-');
      const baseIds = Object.values(PART.base);
      const same = cart.items.filter((it) => (it.properties && (isCp2(it.properties._build) || isCp2(it.properties.Build))) || baseIds.includes(it.variant_id));
      if (same.length) {
        await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: Object.fromEntries(same.map((it) => [it.key, 0])) }) });
      }
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartItems() }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || j.message || 'Could not add this build to the cart.');
      location.href = root + 'checkout';                 // straight to checkout (the build is in the cart, as Shopify needs)
    } catch (e) {
      label.textContent = 'Checkout';
      gate.hidden = false; gate.textContent = e.message;
      addBtn.disabled = false;
    }
  });

  // ---------- clicks ----------
  panel.addEventListener('click', (e) => {
    const b = e.target.closest('button');
    if (!b || b.disabled) return;
    if (b.dataset.layout) {
      state.layout = Number(b.dataset.layout); fixPicks(); update();
    } else if (b.dataset.set) {
      const p = PRESETS.find((x) => x.id === b.dataset.set);
      refPreset = p; Object.assign(state, p.picks); state.locked = !!p.limited;
      fixPicks(); update();
    } else if (b.dataset.toggle) {
      if (state.locked) return;
      const k = b.dataset.toggle;
      state[k] = !state[k]; fixPicks(); update();
    } else if (b.closest('.opt') && b.dataset.id !== undefined) {
      if (state.locked && b.closest('.opt').dataset.slot !== 'socket') return;
      const slot = b.closest('.opt').dataset.slot;
      state[slot] = b.dataset.id;
      if (slot === 'socket' && b.dataset.id === 'mx') state.switch = null;   // Choc switches do not fit MX sockets
      fixPicks(); update();
    }
  });

  // [id, name, price per switch, swatch, Shopify variant id of the "switches" product]
  const SWITCHES = [
    ['black_cloud', 'Kailh Black Cloud 55g', 2.9, '#161618', 47067435073795], ['whale', 'Kailh Whale 55g', 2.5, '#2f45b8', 46002482151683],
    ['islet', 'Kailh Islet 43g', 2.5, '#2f45b8', 46002482118915], ['pink_islet', 'Kailh Pink Islet 35g', 2.5, '#e8a08c', 46840209572099],
    ['spring', 'Kailh Spring 40g', 2.1, '#a8dcc0', 47490552070403], ['raptor', 'Kailh Raptor 37g', 2.5, '#b4dce0', 47022733263107],
    ['glede', 'Kailh Glede 30g', 2.9, '#5a3570', 47791073460483], ['winter', 'Kailh Winter 50g', 2.5, '#b8d4f0', 47067435106563], ['autumn', 'Kailh Autumn 45g', 2.5, '#f0a830', 46890057597187]];
  // [id, name, sub, price, swatch, 3D look, Shopify variant id of the "mx-keycaps" product, legend in the swatch]
  // legend: 'glow' = shine-through (a lit letter in the middle), 'glow-w' = shine-through on a white cap, '' = no legend
  // optional 9th: SVG drawn in the swatch instead (KLP: side view of a bottom / home / top row cap, traced from the
  // 3D model, showing the sculpted saddle-tilted rows in the set's dark grey, misty green and light grey)
  const KLP_ART = '<svg viewBox="0 0 52 40" aria-hidden="true"><g stroke="rgba(0,0,0,.22)" stroke-width=".6" stroke-linejoin="round"><path fill="#5d6063" d="M2 32V19.5Q2 16.4 4.9 16.7C8.6 17.4 12.6 21.4 14.3 24Q16 26.4 16 28.6V32Z"/><path fill="#8fb07a" d="M19 32V27.4Q19 24.9 21.6 24.7C24.6 24.3 27.4 24.3 30.4 24.7Q33 24.9 33 27.4V32Z"/><path fill="#e6e6e2" d="M50 32V19.5Q50 16.4 47.1 16.7C43.4 17.4 39.4 21.4 37.7 24Q36 26.4 36 28.6V32Z"/></g></svg>';
  const KEYCAPS = [
    ['tht_black', 'Taihao THT 60S Split · Black', 'Shine-through PBT', 185, 'radial-gradient(circle at 50% 50%,rgba(85,224,240,.16),transparent 62%),linear-gradient(135deg,#1e1f22,#34363b)', 'keycaps/taihao_tht/black', 46940114649347, 'glow'],
    ['tht_white', 'Taihao THT 60S Split · White', 'Shine-through PBT', 199, 'radial-gradient(circle at 50% 50%,rgba(85,224,240,.14),transparent 62%),linear-gradient(135deg,#f6f6f4,#d9dbdd)', 'keycaps/taihao_tht/white', 48336054059267, 'glow-w'],
    ['lpf40_black', 'LPF Legend Glow 40s · Black', 'Shine-through, low profile', 155, 'radial-gradient(circle at 50% 50%,rgba(85,224,240,.16),transparent 62%),linear-gradient(135deg,#17181b,#2c2e32)', 'keycaps/lpf40/black', 49781694202115, 'glow'],
    ['klp_misty', 'KLP Lamé Mono 40s · Misty Green', 'Dye-sub PBT, low profile', 185, 'linear-gradient(180deg,#f3f4f1,#dfe3dc)', 'keycaps/klp/misty_green', 49781694169347, '', KLP_ART],
    ['jwa_white', 'JWA PBT · White Blank', 'Blank PBT', 50, 'linear-gradient(135deg,#fafafa,#e9e9e9)', 'keycaps/jwa/white', 47683533799683, '']];
  if (LIVE) {
    SWITCHES.forEach((x) => { x[2] = livePrice(x[4], x[2]); });
    KEYCAPS.forEach((x) => { x[3] = livePrice(x[6], x[3]); });
  }
  const soldOut = (vid) => !!(live(vid) && !live(vid)[1]);
  const swStock = (vid) => (live(vid) && live(vid)[2] != null ? live(vid)[2] : null);   // null = not tracked / can oversell
  const swShort = (vid) => soldOut(vid) || (swStock(vid) != null && swStock(vid) < swQty());
  const swLeft = (vid) => (swStock(vid) > 0 ? `Only ${swStock(vid)} left, needs ${swQty()}` : 'Out of stock');
  const variantUrl = (product, id) => `https://xcmkb.com/products/${product}?variant=${id}`;

  const deltaLabel = (d) => (d === 0 ? 'included' : d > 0 ? '+' + rm(d) : '−' + rm(-d));
  const partDelta = (slot) => opt(slot, state[slot]).price - opt(slot, refPreset.picks[slot]).price;
  const presetTotal = (p) => BASES[p.base].price + ['plate', 'bottom', 'case'].reduce((a, slot) => a + opt(slot, p.picks[slot]).price, 0)
    + (p.picks.poron ? EXTRA.poron : 0) + (p.picks.film ? EXTRA.film : 0);

  function update() {
    const m = matchedPreset();
    // presets: no price on the buttons (the total shows the cost); greyed out when a part is out of stock for this layout
    $$('[data-set]', seg).forEach((b) => {
      const p = PRESETS.find((x) => x.id === b.dataset.set);
      b.classList.toggle('on', !!m && m.id === p.id);
      const closed = p.limited && !LIMITED_OPEN;
      b.disabled = closed || !presetOK(p);
      b.title = closed ? 'Limited White: not open for orders yet' : b.disabled ? 'A part is out of stock for this layout' : '';
    });
    $$('[data-layout]', layoutSeg).forEach((b) => b.classList.toggle('on', Number(b.dataset.layout) === state.layout));
    layoutNote.hidden = state.layout !== 36;
    layoutNote.textContent = '36-key layout. Parts and builds that are out of stock for 36 keys are greyed out.';

    for (const div of $$('.opt', panel)) {
      const slot = div.dataset.slot;
      if (slot === 'sound') continue;
      $$('button', div).forEach((b) => {
        b.classList.toggle('on', b.dataset.id === state[slot]);
        if (slot === 'socket') {
          b.disabled = (!!state.locked && b.dataset.id !== state[slot]) || !socketOK(b.dataset.id);
          b.title = socketOK(b.dataset.id) ? '' : 'Out of stock';
          return;
        }
        b.style.display = baseAllows(slot, b.dataset.id, baseOf()) ? '' : 'none';   // base-only parts are hidden, not greyed
        b.disabled = !enabled(slot, b.dataset.id);
        b.title = b.disabled && !state.locked ? (b.dataset.id === 'pp36' && baseOf() !== 'black' ? 'PP (36) is for black builds with 36 keys'
          : b.dataset.id === 'fr4w' && baseOf() !== 'white' ? 'White FR4 belongs to the white base' : b.dataset.id === 'white' && baseOf() !== 'white' ? 'GF PETG white belongs to the white base'
          : 'Out of stock for this layout') : '';
      });
      const tag = div.querySelector('[data-price]');
      if (slot === 'plate') tag.textContent = state.case === 'frame2' ? 'built into the case' : deltaLabel(partDelta('plate'));
      if (slot === 'bottom' || slot === 'case') tag.textContent = deltaLabel(partDelta(slot));
      if (slot === 'socket') tag.textContent = 'included in every build';
    }
    // sound dampening: both optional; Poron is not offered with the Integrated-Plate case
    $('[data-slot="sound"] [data-price]', panel).textContent = deltaLabel((state.poron ? EXTRA.poron : 0) - (refPreset.picks.poron ? EXTRA.poron : 0) + (state.film ? EXTRA.film : 0) - (refPreset.picks.film ? EXTRA.film : 0));
    $$('[data-toggle]', sd).forEach((b) => {
      const k = b.dataset.toggle;
      const offered = k === 'poron' ? poronOK() : filmOK();
      b.classList.toggle('on', !!state[k]);
      b.disabled = !!state.locked || !offered;
      b.title = !offered ? (k === 'poron' ? 'Poron + IXPE does not fit the Integrated-Plate 3D case' : 'Out of stock for this layout') : '';
    });

    const t = total();
    // early bird: the store's automatic discount, shown on the total only (set in the theme editor; ?promo=15 to try it)
    const usd = (n) => (n * 1.07 * MYR_TO_USD).toFixed(2);         // USD estimate includes the +7% for buyers outside Malaysia
    const promo = PROMO && PROMO.pct > 0 ? PROMO : null;
    const save = promo ? Math.round(t * promo.pct) / 100 : 0, now = t - save;
    $('.total', panel).innerHTML = `<span>${m ? m.label : 'Custom build'} · estimated total<br>≈ USD ${usd(now)}</span>` +
      `<strong>${promo ? `<s>${rm(t)}</s>` : ''}${rm(now)}</strong>` +
      (promo ? `<em class="save">${promo.label} −${promo.pct}%: you save ${rm(save)} (≈ USD ${usd(save)})</em>` : '');
    const s = state.switch && sw(state.switch);
    $('#sw-open').innerHTML = `<span><small>Switches · ${swQty()} (${keys()} + 2 spare)</small>${s ? s[1] : 'Choose a set'}</span><b>${s ? rm(s[2] * swQty()) + ' · Change' : 'Open →'}</b>`;
    $('#sw-open').classList.toggle('open', !s);
    const k = state.keycap && kc(state.keycap);
    $('#kc-open').innerHTML = `<span><small>Keycaps</small>${k ? k[1] : 'Choose a set'}</span><b>${k ? rm(k[3]) + ' · Change' : 'Open →'}</b>`;
    $('#kc-open').classList.toggle('open', !k);

    // checkout: every required part must be picked and in stock, and the consent ticked
    const miss = missing();
    gate.hidden = miss.length === 0;
    gate.textContent = miss.length ? 'Choose the ' + miss.join(', ') + ' for this layout to continue.' : '';
    if (addBtn) {
      addBtn.disabled = !tick.checked || miss.length > 0;
      addBtn.title = miss.length ? 'Choose all required parts first' : !tick.checked ? 'Tick the consent to continue to checkout' : '';
    }

    const code = buildCode();
    $('.vtop .mono:last-child', viewerEl).textContent = code;
    $('#copy').dataset.url = buildUrl();
    $('#copy').title = code;
    if (viewer) viewer.show(selection());
  }

  // ---------- drawer: switches / keycaps ----------
  const drawer = $('#drawer');
  let mode = 'keycaps';
  function renderDrawer() {
    const isKc = mode === 'keycaps';
    const mxNote = !isKc && state.socket === 'mx';         // the listed switches are Choc v2 (low profile)
    const items = mxNote ? [] : isKc
      ? KEYCAPS.map(([id, name, sub, price, swatch, , vid, legend, art]) => ({ id, name, sub: soldOut(vid) ? 'Out of stock' : sub, out: soldOut(vid), price: rm(price), swatch, legend, art, url: variantUrl('mx-keycaps', vid) }))
      : SWITCHES.map(([id, name, unit, col, vid]) => ({ id, name, sub: swShort(vid) ? swLeft(vid) : `${swQty()} switches (${keys()} + 2 spare) · RM${unit.toFixed(2)} each`, out: swShort(vid), price: rm(unit * swQty()), swatch: col, url: variantUrl('switches', vid) }));
    const cur = isKc ? state.keycap : state.switch;
    drawer.innerHTML = `<div class="dh"><div><small class="mono">${isKc ? 'Keycaps · fits Choc v2' : 'Switches · Choc v2 · ' + swQty() + ' per bundle'}</small><h3>${isKc ? 'Pick a keycap set' : 'Pick your switches'}</h3></div>` +
      `<button class="x press" data-close aria-label="Close">✕</button></div>` +
      items.map((it) => `<div class="kc-row"><button class="kc press${it.id === cur ? ' on' : ''}" data-pick="${it.id}"${it.out ? ' disabled style="opacity:.45"' : ''}><i class="${it.legend ? 'lit ' + it.legend : ''}" style="background:${it.swatch}">${it.art || (it.legend ? '<em>A</em>' : '')}</i><div><b>${it.name}</b><small>${it.sub}</small></div><span>${it.price}</span></button>` +
        `<a class="kc-link press" href="${it.url}" target="_blank" rel="noopener" title="See ${it.name} on xcmkb.com" aria-label="See ${it.name} on xcmkb.com (opens in a new tab)"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7M9 7h8v8"/></svg></a></div>`).join('') +
      (mxNote ? '<p class="guide" style="margin:10px 2px;font-size:13px;line-height:1.5;color:#3d4248">The switches we list are Choc v2 (low profile). For an MX build, message us and we will help you pick MX switches.</p>' : '') +
      `<button class="kc skip" data-pick="">${isKc ? "I don't need keycaps" : "I don't need switches"}</button>` +
      (isKc ? '' : '<p class="guide" style="margin:10px 2px 0;font-size:12.5px;line-height:1.45;color:#3d4248">Not sure which switch to pick? Read the <a href="https://xcmkb-docs.gitbook.io/doc/purchasing-guide/switches" target="_blank" rel="noopener" style="color:#0a7d92;text-decoration:underline">switches choosing guide</a>.</p>') +
      `<button class="buy press" data-close>Done</button>`;
  }
  drawer.addEventListener('click', (e) => {
    const b = e.target.closest('button');
    if (!b) return;
    if (b.hasAttribute('data-pick')) {
      state[mode === 'keycaps' ? 'keycap' : 'switch'] = b.dataset.pick || null;
      renderDrawer(); update();
    } else if (b.hasAttribute('data-close')) drawer.classList.add('closed');
  });
  const swBtn = $('#sw-open'), kcBtn = $('#kc-open');
  // replace the mockup's own open handlers (they only toggled the static keycap list)
  for (const [btn, m] of [[swBtn, 'switches'], [kcBtn, 'keycaps']]) {
    const fresh = btn.cloneNode(true); btn.replaceWith(fresh);
    fresh.addEventListener('click', () => { mode = m; renderDrawer(); drawer.classList.remove('closed'); });
  }
  drawer.classList.add('closed');

  // ---------- viewer ----------
  const viewerEl = $('.viewer', section);
  // fixed-height stage that stays in view: the panel's height changes with the picks (bundle note, labels),
  // and a stretching stage would re-crop the model
  viewerEl.style.cssText += ';height:min(680px, calc(100vh - 130px));min-height:520px';
  viewerEl.parentElement.style.cssText += ';align-self:start;position:sticky;top:20px';   // the viewer and its note stay in view together
  $$('img.model, .hot', viewerEl).forEach((el) => el.remove());
  const host = document.createElement('div');
  host.style.cssText = 'position:absolute;inset:0';
  viewerEl.prepend(host);
  const loading = document.createElement('div');
  loading.className = 'mono'; loading.style.cssText = 'position:absolute;inset:0;display:grid;place-items:center;color:#7a8088';
  loading.textContent = 'Loading 3D…';
  viewerEl.appendChild(loading);
  const caption = document.createElement('p');
  caption.className = 'mono'; caption.hidden = true;
  caption.style.cssText = 'position:absolute;left:18px;right:18px;top:46px;margin:0;text-align:center;color:#6b7078;font-size:12px';
  viewerEl.appendChild(caption);

  readBuildLink();
  update();
  // ---------- 3D: the viewer bundle (1.4 MB) and model (4 MB) load only when "Build it in 3D" comes near ----------
  if (location.hash !== '#build') {
    await new Promise((res) => {
      const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); res(); } }, { rootMargin: '900px 0px' });
      io.observe(section);
    });
  }
  if (!window.CorneConfigurator) {
    await new Promise((res, rej) => {
      const sc = document.createElement('script');
      sc.src = section.dataset.viewer; sc.onload = res; sc.onerror = rej;
      document.head.appendChild(sc);
    });
  }
  const looks = await fetch(window.CP2_BASE + 'cp2-models-corne_looks.json?v=2').then((r) => r.json());
  const hotspots = await fetch(window.CP2_BASE + 'cp2-models-corne_configurator_hotspots.json').then((r) => r.json());
  viewer = await CorneConfigurator.createViewer(host, {
    glb: window.CP2_BASE + 'cp2-models-corne_configurator.glb', looks, hotspots, autoRotate: false, glow: window.CP2_BASE + 'cp2-models-glow-glow.json', fitHalfWidth: 0.17, debug: location.search.includes('debug'),
    onProgress: (p) => { loading.textContent = 'Loading 3D… ' + Math.round(p * 100) + '%'; },
    onCaption: (list) => { caption.textContent = list.join(' '); caption.hidden = !list.length; },
  });
  loading.remove();
  viewer.show(selection());
  window.corneViewer = viewer;

  // toolbar: Exploded view, RGB backlight, Keycaps, Switches, Top, Bottom, Reset view
  const tools = $$('.vtools button', viewerEl);
  const on = { explode: false, rgb: false, keycaps: true, switches: true };
  tools.forEach((b) => {
    const id = b.dataset.act;
    if (id in on) b.classList.toggle('on', !!on[id]);
    b.addEventListener('click', () => {
      if (id in on) {
        on[id] = !on[id]; b.classList.toggle('on', on[id]);
        if (id === 'rgb') viewerEl.classList.toggle('rgb-on', on[id]);   // lights down: the stage dims so the RGB reads
        ({ explode: viewer.setExploded, rgb: viewer.setRGB, keycaps: viewer.setKeycaps, switches: viewer.setSwitches })[id](on[id]);
      } else {
        if (id === 'home' && on.explode) { on.explode = false; $('[data-act="explode"]', viewerEl).classList.remove('on'); viewer.setExploded(false); }
        viewer.view(id);
      }
    });
  });
})();
